import React from "react";
import "./ComingSoon.css"; // move your CSS here

import logo from "../../../assets/images/light-logo.png";
import vector from "../../../assets/images/Vector5.png";
import mosque from "../../../assets/images/mosque.png";

const ComingSoon = () => {
  return (
    <div className="w-full  flex justify-center relative overflow-hidden items-center
    
    "
style={
     {background: 'linear-gradient(31deg, #2e4049 0%, #0f1d24 100%)'
    }
}    >
    <div className="container">
      <div className="center">
        <img className="logo" src={logo} alt="Logo" />
        <h6 className="mainh6">We're putting the final touches</h6>
        <h1 className="mainh1">Coming Soon</h1>
      </div>

    </div>
          <img className="vector" src={vector} alt="Vector" />
      <img className="mosque" src={mosque} alt="Mosque" />
    </div>
  );
};

export default ComingSoon;
